import apiClient from '../lib/apiClient';

import { PAYMENTS_API_ENDPOINT } from '../constants/apiEndpoints';
import { IPaymentDetailsResponse } from 'hooks/queries/usePaymentDetails';

export async function getPaymentDetails(
  id: string
): Promise<IPaymentDetailsResponse> {
  try {
    const response = await apiClient.get(`${PAYMENTS_API_ENDPOINT}/${id}`);
    return response.data;
  } catch (error: unknown) {
    const err = error as {
      response?: { data?: { message?: string; errors?: string[] } };
    };
    return {
      success: false,
      message: err?.response?.data?.message || 'Payment not found',
      errors: err?.response?.data?.errors || [],
    };
  }
}
